import { put, call, takeEvery } from "redux-saga/effects";
import { safe } from "providers/GeneralProvider/saga";
import {
  getTravelLocationListRequest,
  getTravelLocationListSuccess,
  getTravelLocationListFailure,
  getTravelLocationAllRequest,
  getTravelLocationAllSuccess,
  getTravelLocationAllFailure,
  getCountriesRequest,
  getCountriesSuccess,
  getCountriesFailure,
  createTravelLocationRequest,
  createTravelLocationSuccess,
  createTravelLocationFailure,
  updateTravelLocationRequest,
  updateTravelLocationSuccess,
  updateTravelLocationFailure,
  deleteTravelLocationRequest,
  deleteTravelLocationSuccess,
  deleteTravelLocationFailure,
  restoreTravelLocationRequest,
  restoreTravelLocationSuccess,
  restoreTravelLocationFailure,
} from "./slice";
import request from "utils/api";
import Helper from "utils/helpers";

function* getTravelLocationList({ meta, payload }) {
  try {
    const params = {
      page: payload?.page || 1,
      limit: payload?.limit || 100,
      isDeleted: payload?.isDeleted || false,
      search: payload?.search || undefined,
      country: payload?.country || undefined,
    };

    // Clean up empty params
    Object.keys(params).forEach((key) => {
      if (params[key] === "" || params[key] === undefined) {
        delete params[key];
      }
    });

    const { data } = yield call(request, "api/travel/location", params, {
      method: "GET",
    });

    yield put(getTravelLocationListSuccess(data, meta));
  } catch (error) {
    yield put(getTravelLocationListFailure(error.message, meta));
  }
}

function* getTravelLocationAll({ meta }) {
  try {
    const { data } = yield call(request, "api/travel/location-all", {}, {
      method: "GET",
    });

    yield put(getTravelLocationAllSuccess(data, meta));
  } catch (error) {
    yield put(getTravelLocationAllFailure(error.message, meta));
  }
}

function* getCountries({ meta }) {
  try {
    const { data } = yield call(request, "api/travel/countries", {}, {
      method: "GET",
    });

    yield put(getCountriesSuccess(data, meta));
  } catch (error) {
    yield put(getCountriesFailure(error.message, meta));
  }
}

function* createTravelLocation({ meta, payload }) {
  try {
    const { data } = yield call(request, "api/travel/location", payload, {
      method: "POST",
    });

    yield put(createTravelLocationSuccess(data, meta));
    Helper.toastr("Thành công", "Đã tạo địa điểm mới", "success");
  } catch (error) {
    yield put(createTravelLocationFailure(error.message, meta));
    Helper.toastr("Lỗi", error.message || "Không thể tạo địa điểm", "error");
  }
}

function* updateTravelLocation({ meta, payload }) {
  try {
    const { _id, ...updateData } = payload;
    const { data } = yield call(request, `api/travel/location/${_id}`, updateData, {
      method: "PUT",
    });

    yield put(updateTravelLocationSuccess(data, meta));
    Helper.toastr("Thành công", "Đã cập nhật địa điểm", "success");
  } catch (error) {
    yield put(updateTravelLocationFailure(error.message, meta));
    Helper.toastr("Lỗi", error.message || "Không thể cập nhật địa điểm", "error");
  }
}

function* deleteTravelLocation({ meta, payload }) {
  try {
    yield call(request, `api/travel/location/${payload._id}`, {}, {
      method: "DELETE",
    });

    yield put(deleteTravelLocationSuccess({}, meta));
    Helper.toastr("Thành công", "Đã xóa địa điểm", "success");
  } catch (error) {
    yield put(deleteTravelLocationFailure(error.message, meta));

    // Handle specific error for linked places
    if (error.message?.includes("travel places linked")) {
      Helper.toastr("Lỗi", error.message, "error");
    } else {
      Helper.toastr("Lỗi", "Không thể xóa địa điểm", "error");
    }
  }
}

function* restoreTravelLocation({ meta, payload }) {
  try {
    const { data } = yield call(request, `api/travel/location/${payload._id}/restore`, {}, {
      method: "PUT",
    });

    yield put(restoreTravelLocationSuccess(data, meta));
    Helper.toastr("Thành công", "Đã khôi phục địa điểm", "success");
  } catch (error) {
    yield put(restoreTravelLocationFailure(error.message, meta));
    Helper.toastr("Lỗi", "Không thể khôi phục địa điểm", "error");
  }
}

function* travelLocationSaga() {
  yield takeEvery(getTravelLocationListRequest.type, safe(getTravelLocationList));
  yield takeEvery(getTravelLocationAllRequest.type, safe(getTravelLocationAll));
  yield takeEvery(getCountriesRequest.type, safe(getCountries));
  yield takeEvery(createTravelLocationRequest.type, safe(createTravelLocation));
  yield takeEvery(updateTravelLocationRequest.type, safe(updateTravelLocation));
  yield takeEvery(deleteTravelLocationRequest.type, safe(deleteTravelLocation));
  yield takeEvery(restoreTravelLocationRequest.type, safe(restoreTravelLocation));
}

export default travelLocationSaga;